import React, {useEffect} from 'react'
import AOS from 'aos'; //animation library
import {aboutData} from '../../fake-database/index'; //about-data
import "aos/dist/aos.css"; //animation library style
import './about.css';
import Form from '../../components/Form'

const About = () => {
    //aos animation init
    useEffect(() => {
        AOS.init({
            duration : 700,
        });
    }, []);
    return (
        <main>
            <section id="about" className="about  text-white">
                <div className="row mx-0">
                    <div className='col-md-5 col-12 ms-auto p-0'>
                        <div className="about-title">
                            <h1 className=" text-uppercase pb-4" data-aos="fade-up">About</h1>
                        </div>
                        <div className="about-deatils">
                        {aboutData.deatils.map( deatil => (
                            <p data-aos="fade-up" data-aos-delay="150" key={deatil.id}>{deatil.name}</p>
                        ))}
                        </div>
                        <div className='about-line d-md-block d-none position-relative'></div>
                    </div>
                </div>

                <div className="mt-md-5 mt-sm-2">
                    <div className="about-main-photo">
                        {/* <img src="" alt="" className="img-fluid" /> */}
                        <p className=''>&nbsp;</p>
                    </div>
                </div>

                <div className="about-content text-white my-2">
                    <div className='mision my-md-5 my-sm-2'>
                        <h1 className=" text-uppercase pb-2" data-aos="fade-up">Mision</h1>
                        <p data-aos="fade-up" data-aos-delay="150">{aboutData.mision}</p>
                    </div>

                    <div className='vision my-md-5 my-sm-2'>
                        <h1 className=" text-uppercase pb-2" data-aos="fade-up">Vision</h1>
                        <p data-aos="fade-up" data-aos-delay="150">{aboutData.vision}</p>
                    </div>

                    <div className="clients my-md-5 my-sm-2">
                        <h1 className=" text-uppercase pb-2" data-aos="fade-up">Clients</h1>
                        <div className='about-clients'>
                            {aboutData.clients.map( clients => (
                                <div className=" my-1" key={clients.id}>
                                    <img 
                                        src={clients.image}
                                        alt='client-logo'
                                        className='client-img img-fluid'
                                        data-aos="fade-up"
                                        data-aos-delay="150"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
            <Form/>
        </main>
    )}
export default About